import React, { Component } from "react";
import Faker from "faker";
import moment from "moment";

export default class NotificationCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastEnter: moment(),
    };
  }
  checkHover() {
    const now = moment();
    const { lastEnter } = this.state;

    if (now.valueOf() - lastEnter >= 500) {
      if (this.props.onSeen) {
        this.props.onSeen();
      }
    }
  }
  render() {
    let { type } = this.props;
    let notification = null;
    let caption = null;
    switch (type) {
      case "update":
        {
          caption = (
            <strong>
              Timesheet Updated &nbsp;
              <i className="fa fa-caret-up text-success" />
            </strong>
          );
          notification = (
            <span>
              Update : Make{" "}
              <span className="newstatus">{this.props.newstatus}</span>
            </span>
          );
        }
        break;
      case "updates":
        {
          notification = (
            <span>
              <span>{this.props.newstatus}</span>
            </span>
          );
        }
        break;
      case "file":
        {
          caption = "uploaded a file on case";
          notification = (
            <div className="file">
              <i className="fa fa-file-pdf-o" />
              {Faker.commerce.productMaterial()}
            </div>
          );
        }
        break;
      default:
        caption = "commented on your case";
        notification = <small>{Faker.lorem.sentence(5)}</small>;
    }

    return (
      <a
        href={this.props.notification.url ? this.props.notification.url : "#"}
        onMouseLeave={(x) => this.checkHover()}
        onMouseEnter={(e) =>
          this.setState({
            lastEnter: moment(),
          })
        }
      >
        <div className={"notification " + (this.props.seen ? "" : "unseen")}>
          <small className="notificationdate">
            {this.props.date || "29 Aug 2019 08:23"}
          </small>
          {this.props.children ? (
            this.props.children
          ) : (
            <React.Fragment>
              <div className="headline">
                {type == "update" || type == "updates" ? null : (
                  <strong>
                    {Faker.fake("{{name.firstName}} {{name.lastName}}")}
                    &nbsp;
                  </strong>
                )}
                {caption}
                {type == "update" || type == "updates" ? null : (
                  <strong>&nbsp;#{Faker.random.number(9999)}</strong>
                )}
              </div>
              {notification}
            </React.Fragment>
          )}
        </div>
      </a>
    );
  }
}
